import { decodeTenant, TenantStorage } from './session-decode';
import { notifyTenantChanged } from './tenant-change';

// Mesmas chaves do TenantService (app/const.ts): tenant guarda a conta ativa
// (mesmo encoding do user_instance) e nome_conta guarda só o nome, para que a
// folha Angular leia o que o React grava e vice-versa.
const TENANT_KEY = 'tenant';
const ACCOUNT_NAME_KEY = 'nome_conta';

/** Lê sessionStorage['tenant'] e decodifica; null se ausente/ilegível. */
export function getTenantStorage(): TenantStorage | null {
  try {
    return decodeTenant(sessionStorage.getItem(TENANT_KEY));
  } catch {
    return null;
  }
}

/** Lê sessionStorage['nome_conta'] (JSON string); null se ausente/ilegível. */
export function getTenantName(): string | null {
  try {
    const raw = sessionStorage.getItem(ACCOUNT_NAME_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as string | null;
  } catch {
    return null;
  }
}

/**
 * Grava sessionStorage['tenant'] com o mesmo encoding do TenantService
 * (`btoa(toBinaryStr(JSON.stringify(tenant)))`), inverso exato do que
 * `decodeTenant` decodifica. toBinaryStr apenas normaliza aspas curvas antes do
 * encode (evita "outside of the Latin1 range" do btoa); replicado aqui para não
 * criar dependência do módulo Angular a partir do React.
 */
export function saveTenantStorage(tenant: TenantStorage): void {
  try {
    const binary = JSON.stringify(tenant).replaceAll('\u2019', "'");
    sessionStorage.setItem(TENANT_KEY, btoa(binary));
    notifyTenantChanged();
  } catch {
    // Storage indisponível (modo privado, quota, etc.) — best-effort.
  }
}

/** Grava sessionStorage['nome_conta'] como JSON string; null remove a chave. */
export function saveTenantName(name: string | null): void {
  try {
    if (name === null) {
      sessionStorage.removeItem(ACCOUNT_NAME_KEY);
      return;
    }
    sessionStorage.setItem(ACCOUNT_NAME_KEY, JSON.stringify(name));
  } catch {
    // Storage indisponível — best-effort.
  }
}

/** Remove sessionStorage['tenant']. */
export function clearTenantStorage(): void {
  try {
    sessionStorage.removeItem(TENANT_KEY);
    notifyTenantChanged();
  } catch {
    // Storage indisponível — best-effort.
  }
}
